import { InspectorControls } from '@wordpress/block-editor';
import {
	PanelBody,
	SelectControl,
	ToggleControl,
	__experimentalUnitControl as UnitControl,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';

const DIRECTION_OPTIONS = [
	{ label: __( 'Left', 'brandy-blocks' ), value: 'left' },
	{ label: __( 'Right', 'brandy-blocks' ), value: 'right' },
];

const SPEED_OPTIONS = [
	{ label: __( 'Slow', 'brandy-blocks' ), value: 'slow' },
	{ label: __( 'Medium', 'brandy-blocks' ), value: 'medium' },
	{ label: __( 'Fast', 'brandy-blocks' ), value: 'fast' },
	{ label: __( 'Very Fast', 'brandy-blocks' ), value: 'very-fast' },
	
];

export default function AllInspectorSettings( { attributes, setAttributes } ) {
	const { direction, speed, infinite, pauseOnHover, gap, startOffscreen } = attributes;

	return (
		<InspectorControls>
			<PanelBody
				title={ __( 'Scrolling Settings', 'brandy-blocks' ) }
				initialOpen={ true }
			>
				<SelectControl
					label={ __( 'Direction', 'brandy-blocks' ) }
					value={ direction }
					options={ DIRECTION_OPTIONS }
					onChange={ ( value ) =>
						setAttributes( { direction: value } )
					}
				/>
				<SelectControl
					label={ __( 'Speed', 'brandy-blocks' ) }
					value={ speed }
					options={ SPEED_OPTIONS }
					onChange={ ( value ) =>
						setAttributes( { speed: value } )
					}
				/>
				<UnitControl
					label={ __( 'Gap', 'brandy-blocks' ) }
					value={ gap }
					onChange={ ( value ) =>
						setAttributes( { gap: value } )
					}
					units={ [
						{ value: 'px', label: 'px' },
						{ value: 'em', label: 'em' },
						{ value: 'rem', label: 'rem' },
					] }
				/>
				<ToggleControl
					label={ __( 'Infinite Loop', 'brandy-blocks' ) }
					checked={ infinite }
					onChange={ ( value ) =>
						setAttributes( { infinite: value } )
					}
				/>
				<ToggleControl
					label={ __( 'Pause on Hover', 'brandy-blocks' ) }
					checked={ pauseOnHover }
					onChange={ ( value ) =>
						setAttributes( { pauseOnHover: value } )
					}
				/>
				<ToggleControl
					label={ __( 'Start Offscreen', 'brandy-blocks' ) }
					help={ __( 'Content enters from outside the visible area', 'brandy-blocks' ) }
					checked={ startOffscreen }
					onChange={ ( value ) =>
						setAttributes( { startOffscreen: value } )
					}
				/>
			</PanelBody>
		</InspectorControls>
	);
}
